import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SkillItem } from '@app/onboarding/onboarding.model';

/**
 * Tag skills dropdown Component
 * The component displays skills based on the section title. Currently
 * this is only used in the HMM onboarding pages
 *
 * @param toggleSkill {EventEmitter<Skill>} Output of a toggled skill
 * @param skills {Skill[]} Skills to be displayed in the section
 * @param sectionTitle {string} Dropdown section title
 *
 * @example
 * ```
 * <dgx-tag-dropdown [skills]="skills"
 *    [sectionTitle]="sectionTitle"
 *    (toggleSkill)="onToggleSkill($event)">
 * </dgx-tag-dropdown>
 * ```
 */
@Component({
  selector: 'dgx-tag-dropdown',
  templateUrl: './tag-dropdown.component.html',
  styleUrls: ['./tag-dropdown.component.scss'],
})
export class TagDropdownComponent {
  @Output()
  public toggleSkill: EventEmitter<SkillItem> = new EventEmitter<SkillItem>();
  @Input()
  public skills: SkillItem[];
  @Input()
  public sectionTitle: string;

  /**
   * Emit the skill back to the parent component that the user has toggled.
   *
   * @param skill skill user toggled
   */
  public onToggleSkill(skill: SkillItem): void {
    this.toggleSkill.emit(skill);
  }
}
